var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "plombs_maker fs-xl" },
    [
      _c(
        "b-overlay",
        { attrs: { show: _vm.is_load, rounded: "sm" } },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c("h1", { staticClass: "title text-center pb-5 mt-5" }, [
                _vm._v("Створення"),
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "doc_title" },
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "12", xl: "12", xs: "12", sm: "12" } },
                    [
                      _c(
                        "b-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "b-row",
                            { staticClass: "doc_title mt-3" },
                            [
                              _c("b-col", { attrs: { sm: "3" } }, [
                                _c("label", { attrs: { for: "doc_title" } }, [
                                  _vm._v("Назва *"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { sm: "4" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      state: _vm.is_valid_name,
                                      maxlength: "130",
                                      id: "doc_title",
                                      size: "sm",
                                    },
                                    model: {
                                      value: _vm.form.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "name", $$v)
                                      },
                                      expression: "form.name",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-invalid-feedback",
                                    { attrs: { id: "input-live-feedback" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\tПотрібно заповнити назву\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "doc_title_s mt-3" },
                            [
                              _c("b-col", { attrs: { sm: "3" } }, [
                                _c("label", { attrs: { for: "doc_title_s" } }, [
                                  _vm._v("Коротка Назва *"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { sm: "4" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      state: _vm.is_valid_small_name,
                                      maxlength: "130",
                                      id: "doc_title_s",
                                      size: "sm",
                                    },
                                    model: {
                                      value: _vm.form.small_name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "small_name", $$v)
                                      },
                                      expression: "form.small_name",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-invalid-feedback",
                                    { attrs: { id: "input-live-feedback" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\tПотрібно заповнити коротку назву\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "doc_tov_s mt-3" },
                            [
                              _c("b-col", { attrs: { sm: "3" } }, [
                                _c("label", { attrs: { for: "doc_tov_s" } }, [
                                  _vm._v(
                                    "Виберiть з випадаючого списку організацію *"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { sm: "4" } },
                                [
                                  _c("b-form-group", { attrs: { label: "" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "select_step width-mobile-auto",
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            state: _vm.is_valid_tov,
                                            "value-field": "id",
                                            "text-field": "small_title",
                                            options: _vm.tov_list,
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.form.tov_id,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "tov_id", $$v)
                                            },
                                            expression: "form.tov_id",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "doc_tov_s mt-3" },
                            [
                              _c("b-col", { attrs: { sm: "3" } }, [
                                _c("label", { attrs: { for: "doc_tp_s" } }, [
                                  _vm._v("Виберiть з випадаючого списку тип *"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { sm: "4" } },
                                [
                                  _c("b-form-group", { attrs: { label: "" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "select_step width-mobile-auto",
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            state: _vm.is_valid_type,
                                            "value-field": "id",
                                            "text-field": "name",
                                            options: _vm.type_list,
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.form.type_id,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "type_id", $$v)
                                            },
                                            expression: "form.type_id",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "button_block row mt-5 pb-5" }, [
            _c(
              "div",
              {
                staticClass:
                  "next_step col-xs-12 col-lg-4 col-sm-4 col-xl-3 mt-3",
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-lg btn-block btn-outline-success waves-effect waves-themed",
                    attrs: { disabled: !_vm.can_save },
                    on: { click: _vm.save },
                  },
                  [
                    _c("span", { staticClass: "fal fa-download mr-1" }),
                    _vm._v("\n\t\t\t\t\tСтворити\n\t\t\t\t"),
                  ]
                ),
              ]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }